import { z } from 'zod';

const PopularProductsDummySchema = z.object({
  brandNo: z.number().describe('[Dummy] 브랜드 번호'),
  isSoldOut: z.boolean().describe('[Dummy] 품절 여부'),
  hasNextPage: z.boolean().describe('[Dummy] 다음 페이지 존재 여부'),
});
export const PopularProductsDummy: z.infer<typeof PopularProductsDummySchema> = {
  brandNo: 0,
  isSoldOut: false,
  hasNextPage: false,
};

export const PopularProductsSchema = PopularProductsDummySchema.extend({
  imageUrl: z.string().describe('이미지 URL'),
  brandName: z.string().describe('브랜드명'),
  goodsName: z.string().describe('상품명'),
  goodsNo: z.string().describe('상품번호'),
  linkUrl: z.string().describe('링크 URL'),
  price: z.number().int().describe('가격'),
  salesRate: z.number().int().describe('할인율 (%)'),
  isLiked: z.boolean().describe('좋아요 여부'),
  largeCategoryNo: z.number().optional().nullable().describe('대카테고리 번호'),
  largeCategoryName: z.string().optional().nullable().describe('대카테고리명'),
  middleCategoryNo: z.number().optional().nullable().describe('중카테고리 번호'),
  middleCategoryName: z.string().optional().nullable().describe('중카테고리명'),
  smallCategoryNo: z.number().optional().nullable().describe('소카테고리 번호'),
  smallCategoryName: z.string().optional().nullable().describe('소카테고리명'),
});

export type PopularProductListItem = z.infer<typeof PopularProductsSchema>;

export const PopularProductsServiceDTOSchema = z.object({
  total: z.number(),
  list: z.array(PopularProductsSchema).describe('판매 랭킹 상품 리스트'),
  pagination: z.object({
    currentPage: z.number(),
    pageSize: z.number(),
    hasNextPage: z.boolean(),
    nextPage: z.string().nullable(),
  }),
});
export type PopularProductsServiceDTO = z.infer<typeof PopularProductsServiceDTOSchema>;
